<template>
  <div class="md-layout md-alignment-center-center search-container">
    <div style="width: 70%;" class="md-layout-item md-size-60 md-alignment-center-center searchbar-item md-small-size-50">
      <form :action="searchAction" method="get" target="_blank" id="search-form" @submit.prevent="search">
        <md-autocomplete :class="invalidQuery"
          v-model="googleSearchSelected"
          :md-options="searchItems"
          md-layout="box"
          md-min-length="1"
          md-dense data-gname="storesearch"
          title="Enter your query and then select the search engine">
          <label>Google Search</label>
        </md-autocomplete>
      </form>
    </div>
    <div class="md-alignment searchbar-items" style="z-index: 0;">
      <div class="md-layout-item md-size-100">
        <md-button title="Google Search" class="md-icon-button md-raised md-primary google-btn" @click="search('google')">
          <img :src="`${publicPath}google-icon.svg`">
        </md-button>
        <md-button title="Amazon Search" class="md-icon-button md-raised md-accent amazon-btn" @click="search('amazon')">
          <i class="fab fa-amazon"></i>
        </md-button>
        <md-button title="Youtube Search" class="md-icon-button md-raised md-primary youtube-btn" @click="search('youtube')">
          <i class="fab fa-youtube"></i>
        </md-button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  data: () => ({
    googleSearchSelected: '',
    searchItems: [],
    searchAction: null,
    publicPath: process.env.BASE_URL,
    html: '',
  }),
  created() {
    this.googleSearchSelected = this.queryFromUrl();
  },
  methods: {
    /**
     * The q parameter, decoded.
     *
     * This used to slice the raw location.search by character offset and
     * assign it straight to the box, so /google/search?q=test%20result put
     * the literal "test%20result" in front of the reader - the page telling
     * them they searched for something they did not type. URLSearchParams
     * decodes, and finds q wherever it is in the string rather than only
     * when it happens to be first.
     */
    queryFromUrl() {
      try {
        return new URLSearchParams(window.location.search).get('q') || '';
      } catch (e) {
        return '';
      }
    },
    /**
     * Already looking at results, as opposed to searching from anywhere else.
     */
    onResultsPage() {
      return !!this.$route && this.$route.name === 'googleSearch';
    },
    search(website) {
      // Also invoked as a submit handler, where the argument is an Event -
      // anything that is not a known engine falls through to Google, which is
      // what the original default case did.
      const raw = (this.googleSearchSelected || '').toString().trim();

      if (!raw) {
        this.googleSearchSelected = null; // to show the border
        setTimeout(() => {
          this.googleSearchSelected = '';
        }, 500);
        return;
      }

      // Every one of these was built by interpolating the query straight into
      // a URL, so an & ended the parameter early and a # ended the URL:
      // "rock & roll" searched for "rock". encodeURIComponent for the two
      // external engines, and router.resolve for our own route, which encodes
      // the query object itself.
      let url;
      switch (website) {
        case 'amazon':
          url = `https://www.amazon.com/s?k=${encodeURIComponent(raw)}`;
          break;
        case 'youtube':
          url = `https://www.youtube.com/results?search_query=${encodeURIComponent(raw)}`;
          break;
        default:
          url = this.$router.resolve({ name: 'googleSearch', query: { q: raw } }).href;
      }

      // Refining a search while already reading results replaced the page you
      // were on with a new tab, so four attempts at a query left four tabs
      // behind. Navigate in place instead - a real navigation rather than a
      // router push, because the CSE reads the query from the URL once, when
      // it loads, and a push would leave the old results on screen.
      const isGoogle = website !== 'amazon' && website !== 'youtube';
      if (isGoogle && this.onResultsPage()) {
        window.location.assign(url);
        return;
      }

      this.googleSearchSelected = '';
      window.open(url, '_blank');
    },
  },
  computed: {
    invalidQuery() {
      return this.googleSearchSelected != null ? '' : 'invalid-query';
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/layout/search-bar.scss';
</style>
